import fetchJsonp from "fetch-jsonp";

function youtubeSearch(searchValue, nextPageToken) {
  const youtubeBaseUrl =
    "https://www.googleapis.com/youtube/v3/search?videoEmbeddable=true&type=video&maxResults=12";
  const apiKey = process.env.VUE_APP_YOUTUE_API_KEY;
  let searchUrl = "";
  if (nextPageToken) {
    searchUrl = `${youtubeBaseUrl}&part=snippet&q=${searchValue}&key=${apiKey}&pageToken=${nextPageToken}`;
  } else {
    searchUrl = `${youtubeBaseUrl}&part=snippet&q=${searchValue}&key=${apiKey}`;
  }
  return new Promise((resolve, reject) => {
    fetch(searchUrl, {
      method: "get"
    })
      .then(res => {
        return res.json();
      })
      .then(function(response) {
        let searchResult = {
          nextPageToken: response.nextPageToken,
          items: []
        };
        response.items.map(item => {
          searchResult.items.push({
            title: unescape(item.snippet.title),
            image: { source: item.snippet.thumbnails.high.url },
            // proportion:
            //   item.snippet.thumbnails.high.width /
            //   item.snippet.thumbnails.high.height,
            proportion: 1.594405594405594,
            playMedia: false,
            approved: true,
            video: {
              id: item.id.videoId,
              source: item.id.videoId,
              type: item.id.kind
            }
          });
        });
        resolve(searchResult);
      })
      .catch(e => {
        window.console.log(e);
        reject();
      });
  });
}

function googleImageSearch(searchValue, start) {
  start = start || 1;
  const apiKey = process.env.VUE_APP_GOOGLE_IMAGE_API_KEY;
  const cx = process.env.VUE_APP_GOOGLE_IMAGE_API_CX;
  const searchUrl = `https://www.googleapis.com/customsearch/v1?num=10&key=${apiKey}&q=${searchValue}&searchType=image&rights=cc_publicdomain%2Ccc_attribute%2Ccc_sharealike&alt=json&cx=${cx}&start=${start}`;

  return new Promise((resolve, reject) => {
    fetch(searchUrl, {
      method: "get"
    })
      .then(res => {
        return res.json();
      })
      .then(function(response) {
        const searchResult = {
          start: start ? start + 10 : 1,
          items: []
        };
        response.items.map(item => {
          searchResult.items.push({
            title: unescape(item.title),
            image: { source: item.link },
            approved: true,
            proportion: item.image.width / item.image.height,
            type: item.mime
          });
        });
        resolve(searchResult);
      })
      .catch(e => {
        window.console.log(e);
        reject();
      });
  });
}

function giphySearch(searchValue, offset) {
  offset = offset || 1;
  const apiKey = process.env.VUE_APP_GIPHY_API_KEY;
  const searchUrl = `//api.giphy.com/v1/gifs/search?limit=10&api_key=${apiKey}&q=${searchValue}&offset=${offset}`;

  return new Promise((resolve, reject) => {
    fetch(searchUrl, {
      method: "get"
    })
      .then(res => {
        return res.json();
      })
      .then(function(response) {
        const searchResult = {
          offset: offset ? offset + 10 : 1,
          items: []
        };
        response.data.map(item => {
          searchResult.items.push({
            title: unescape(item.title),
            image: { source: item.images.original_still.url },
            approved: true,
            proportion:
              item.images.original_mp4.width / item.images.original_mp4.height,
            playMedia: false,
            video: {
              source: item.images.original_mp4.mp4,
              type: "giphy"
            }
          });
        });
        resolve(searchResult);
      })
      .catch(e => {
        window.console.log(e);
        reject();
      });
  });
}

function interactiveVideoSearch(searchValue) {
  const searchUrl = `//interactivevideo.swisstxt.ch/node/cling/api/video/getPinwallVideos?search=${searchValue}`;

  return new Promise((resolve, reject) => {
    fetch(searchUrl, {
      method: "get"
    })
      .then(res => {
        return res.json();
      })
      .then(function(response) {
        const searchResult = {
          items: []
        };
        response.map(item => {
          if (item.thumbnailUrl && item.thumbnailUrl !== "") {
            searchResult.items.push({
              title: item.title,
              image: {
                source:
                  "/cdn/srg/385cb1847f19f06f405cf288-5_E-LEARNINGHIVEImport_720p_(Source).jpg"
              },
              playMedia: false,
              approved: true,
              proportion: 1.594405594405594,
              video: {
                type: "interactiveVideo",
                source: item.id,
                id: item.id
              }
            });
          }
        });
        resolve(searchResult);
      })
      .catch(e => {
        window.console.log(e);
        reject();
      });
  });
}

function autoComplete(searchValue) {
  const apiKey = process.env.VUE_APP_GOOGLE_IMAGE_API_KEY;
  const searchUrl = `//suggestqueries.google.com/complete/search?hl=en&ds=yt&client=youtube&hjson=t&cp=1&q=${searchValue}&key=${apiKey}&format=5&alt=json&callback=?`;
  return new Promise((resolve, reject) => {
    fetchJsonp(searchUrl, {
      method: "get"
    })
      .then(res => {
        return res.json();
      })
      .then(function(response) {
        let searchList = [];
        let searchItems = response[1];
        searchItems.map(item => {
          searchList.push(item[0]);
        });
        return resolve(searchList);
      })
      .catch(e => {
        window.console.log(e);
        reject();
      });
  });
}

export {
  youtubeSearch,
  googleImageSearch,
  giphySearch,
  interactiveVideoSearch,
  autoComplete
};
